export function setCookie(name: string, value: string, maxAge: number): void {
    const nodeEnv = import.meta.env.VITE_NODE_ENV || (import.meta.env.PROD ? 'production' : 'development');
    const secure = nodeEnv === 'production' ? '; Secure' : '';
    const sameSite = '; SameSite=Strict';
    document.cookie = `${name}=${value}; Max-Age=${maxAge}; Path=/${secure}${sameSite}`;
}

export function getCookie(name: string): string | null {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

export function deleteCookie(name: string): void {
    document.cookie = `${name}=; Max-Age=0; Path=/`;
}
